<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="text-center">
    <v-container>
      <v-row justify="center" align="center" class="mt-5">
        <v-col cols="12" md="3" class="d-flex align-center">
          <v-select
            v-model="selectedOrderStatusId"
            :items="orderStatusOptions"
            item-text="name"
            item-value="id"
            :label="$t('selectOrderStatus')"
            outlined
            dense
            hide-details
          >
          </v-select>
        </v-col>
        <v-col cols="6" md="3" class="d-flex align-center">
          <v-menu
            v-model="fromMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formattedFromDate"
                :label="$t('startDate')"
                outlined
                dense
                hide-details
                readonly
                prepend-inner-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="customFromDate"
              no-title
              scrollable
              show-adjacent-months
              :locale="$i18n.locale"
              color="primary"
              :max="customToDate || undefined"
              @input="fromMenu = false"
            />
          </v-menu>
        </v-col>
        <v-col cols="6" md="3" class="d-flex align-center">
          <v-menu
            v-model="toMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formattedToDate"
                :label="$t('endDate')"
                outlined
                dense
                hide-details
                readonly
                prepend-inner-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="customToDate"
              no-title
              scrollable
              show-adjacent-months
              :locale="$i18n.locale"
              color="primary"
              :min="customFromDate || undefined"
              @input="toMenu = false"
            />
          </v-menu>
        </v-col>
        <v-col cols="12" md="3" class="d-flex align-center">
          <v-btn
            color="primary"
            :disabled="!canGenerate"
            @click="printAssignedJobs()"
          >
            {{ $t('generate') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" class="mt-1">
        <v-col cols="12" md="6" class="d-flex justify-center align-center">
          <span class="mr-4 text-body-2">{{ $t('groupBy') }}:</span>
          <v-btn-toggle v-model="groupBy" mandatory dense color="primary">
            <v-btn value="order" small>{{ $t('groupByOrder') }}</v-btn>
            <v-btn value="worker" small>{{ $t('groupByWorker') }}</v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
export default {
  name: 'AssignedJobs',

  data: () => ({
    customFromDate: '',
    customToDate: '',
    fromMenu: false,
    toMenu: false,
    selectedOrderStatusId: '',
    groupBy: 'order'
  }),
  created() {
    const today = moment().format('YYYY-MM-DD');
    this.customFromDate = today;
    this.customToDate = today;
  },
  computed: {
    ...mapGetters('orderStatuses', ['allOrderStatuses']),

    orderStatusOptions() {
      return [
        { id: '', name: this.$t('allOrderStatuses') },
        ...this.allOrderStatuses.filter(
          status => status.id !== '2723441b-e401-4dd7-9cd1-10d3cc066574' //Final order status id
        )
      ];
    },

    formattedFromDate() {
      return this.customFromDate
        ? moment(this.customFromDate).format('DD/MM/YYYY')
        : '';
    },

    formattedToDate() {
      return this.customToDate
        ? moment(this.customToDate).format('DD/MM/YYYY')
        : '';
    },

    canGenerate() {
      return (
        Boolean(this.customFromDate) &&
        Boolean(this.customToDate) &&
        !moment(this.customToDate).isBefore(this.customFromDate, 'day')
      );
    }
  },
  methods: {
    formatDate(date) {
      const isoString = moment(date).format('YYYY-MM-DDTHH:mm:ss.SSSSSSSZ');
      return isoString.replace(/:/g, '%3A');
    },

    printAssignedJobs() {
      if (!this.canGenerate) {
        console.warn('Please select a valid date range.');
        return;
      }
      const start = moment(this.customFromDate).startOf('day');
      const end = moment(this.customToDate).endOf('day');
      this.$root.$emit(
        'print-assigned-jobs-pdf',
        this.formatDate(start),
        this.formatDate(end),
        this.selectedOrderStatusId,
        this.groupBy
      );
    }
  }
};
</script>

<style scoped>
@import './ScopedStyles.css';
</style>
